import { useSyncExternalStore } from 'react';

const SERVICE_TAG = '[ORIENTATION]';

/**
 * Returns the current orientation state based on media query
 */
const getSnapshot = (): boolean => {
  return window.matchMedia('(orientation: landscape)').matches;
};

/**
 * Server-side snapshot - default to portrait
 */
const getServerSnapshot = (): boolean => {
  return false;
};

/**
 * Subscribe to orientation changes
 */
const subscribe = (callback: () => void): (() => void) => {
  const mediaQuery = window.matchMedia('(orientation: landscape)');

  const handleChange = () => {
    console.debug(`${SERVICE_TAG} Orientation changed:`, {
      isLandscape: mediaQuery.matches
    });
    callback();
  };

  mediaQuery.addEventListener('change', handleChange);
  return () => mediaQuery.removeEventListener('change', handleChange);
};

/**
 * Hook to detect landscape orientation
 * Uses useSyncExternalStore for optimal React 18 compatibility
 * @returns true if the device is in landscape orientation
 */
export function useIsLandscape(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
